import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// We authenticate via Bearer token (localStorage) — disable withCredentials so
// the API can keep `Access-Control-Allow-Origin: *` and avoid preflight CORS
// failures on the deployed preview URL.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

// Attach Authorization header from localStorage as a fallback when cookies are blocked
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Auto-inject SuperAdmin View-As header so every API call is scoped to the
  // impersonated user (backend treats this as read-only).
  const viewAs = localStorage.getItem("view_as_id");
  if (viewAs) {
    config.headers = config.headers || {};
    config.headers["x-view-as"] = viewAs;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
